export default __webpack_public_path__ + "static/media/bursapediary.eefb1ed5.jpg";